import React from "react";

const ProductNav = ({ setView }) => {
  return (
    <div>
      <div className="container product_nav">
        <div className="">
          <h3 className="roboto">Filter Products</h3>
        </div>
        <div className="product_nav_right">
          <div className="product_view_opt">
            <i className="bi bi-list-ul" onClick={() => setView("list")}></i>
            <i className="bi bi-grid" onClick={() => setView("is3x3")}></i>
            <i
              className="bi bi-grid-3x3-gap"
              onClick={() => setView("is4x4")}
            ></i>
          </div>
          <select name="cars" id="cars">
            <option value="volvo">Volvo</option>
            <option value="saab">Saab</option>
            <option value="mercedes">Mercedes</option>
            <option value="audi">Audi</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ProductNav;
